{
  "version": 1,
  "asset_id": "26a6fcc4-aeb4-41f4-b14a-fa77423c9e0c",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/26a6fcc4-aeb4-41f4-b14a-fa77423c9e0c/michael-hoffert-96.webp",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/26a6fcc4-aeb4-41f4-b14a-fa77423c9e0c/michael-hoffert-96.webp",
  "original_filename": "michael-hoffert-96.webp",
  "size": 2666,
  "content_type": "image/webp",
  "created_at": "2026-09-18T14:37:00Z"
}
